module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 var response = content.response 
__p+='\n';
 var productSuggestions = content.productSuggestions 
__p+='\n';
 var collectionSuggestions = content.collectionSuggestions 
__p+='\n';
 var pageSuggestions = content.pageSuggestions 
__p+='\n';
 var articleSuggestions = content.articleSuggestions 
__p+='\n';
 var querySuggestions = content.querySuggestions 
__p+='\n';
 var searchPageResults = content.searchPageResults 
__p+='\n\n<div id="predictive-search-results" role="listbox">\n	<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">\n\n		';
 if (querySuggestions && querySuggestions.length >= 1) { 
__p+='\n		<div class="predictive-search-queries">\n			<h3 id="predictive-search-queries" class="predictive-search__heading">Top Suggestions</h3>\n			<ul id="predictive-search-results-queries-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-queries">\n				';
 $(querySuggestions).each(function() { 
__p+='\n					<li id="predictive-search-option-query" class="predictive-search__list-item" role="option" aria-selected="false">\n						<a href="'+
((__t=( this.url ))==null?'':__t)+
'" class="predictive-search__item link link--text" tabindex="-1">\n							<div class="predictive-search__item-content">\n								<p class="predictive-search__item-heading predictive-search__item-query-result">'+
((__t=( this.text ))==null?'':__t)+
'</p>\n							</div>\n						</a>\n					</li>\n				';
 }) 
__p+='\n			</ul>\n		</div>\n		';
 } 
__p+='\n		\n		';
 if (productSuggestions && productSuggestions.length >= 1) { 
__p+='\n		<div class="predictive-search-products">\n			<ul id="predictive-search-results-products-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-products">\n				';
 $(productSuggestions).each(function() { 
__p+='\n				    <li id="predictive-search-option-product" class="predictive-search__list-item" role="option" aria-selected="false">\n				    	<a href="'+
((__t=( this.url ))==null?'':__t)+
'" class="predictive-search__item link link--text" tabindex="-1">\n				    		<div class="predictive-search__item-content">\n				    			<img class="predictive-search__image" src="'+
((__t=(this.featured_image.url ))==null?'':__t)+
'" alt="'+
((__t=(this.featured_image.alt ))==null?'':__t)+
'" width="50" height="50"/>\n				    		</div>\n				    		<div class="predictive-search__item-content info">\n				    			<p class="predictive-search__item-heading predictive-search__item-product-result product-type">'+
((__t=( this.eyebrow ))==null?'':__t)+
'</p>\n				    			<p class="predictive-search__item-heading predictive-search__item-product-result product-title">'+
((__t=( this.title ))==null?'':__t)+
'</p>\n				    			<p class="predictive-search__item-product-result product-price">From $'+
((__t=( this.price ))==null?'':__t)+
'</p>\n				    		</div>\n						</a>\n					</li>\n				';
 }) 
__p+='\n			</ul>\n		</div>\n		';
 } 
__p+='\n\n		';
 if (collectionSuggestions && collectionSuggestions.length >= 1) { 
__p+='\n		<div class="predictive-search-collections">\n			<h3 id="predictive-search-collections" class="predictive-search__heading">Collections</h3>\n			<ul id="predictive-search-results-collections-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-collections">\n				';
 $(collectionSuggestions).each(function() { 
__p+='\n					<li id="predictive-search-option-collection" class="predictive-search__list-item" role="option" aria-selected="false">\n						<a href="'+
((__t=( this.url ))==null?'':__t)+
'" class="predictive-search__item link link--text" tabindex="-1">\n							<div class="predictive-search__item-content">\n								<p class="predictive-search__item-heading predictive-search__item-collection-result">'+
((__t=( this.title ))==null?'':__t)+
'</p>\n							</div>\n						</a>\n					</li>\n				';
 }) 
__p+='\n			</ul>\n		</div>\n		';
 } 
__p+='\n\n		';
 if (pageSuggestions && pageSuggestions.length >= 1) { 
__p+='\n		<div class="predictive-search-pages">\n			<h3 id="predictive-search-pages" class="predictive-search__heading">Pages</h3>\n			<ul id="predictive-search-results-pages-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-pages">\n				';
 $(pageSuggestions).each(function() { 
__p+='\n					<li id="predictive-search-option-page" class="predictive-search__list-item" role="option" aria-selected="false">\n						<a href="'+
((__t=( this.url ))==null?'':__t)+
'" class="predictive-search__item link link--text" tabindex="-1">\n							<div class="predictive-search__item-content">\n								<p class="predictive-search__item-heading predictive-search__item-page-result">'+
((__t=( this.title ))==null?'':__t)+
'</p>\n							</div>\n						</a>\n					</li>\n				';
 }) 
__p+='\n			</ul>\n		</div>\n		';
 } 
__p+='\n\n		';
 if (articleSuggestions && articleSuggestions.length >= 1) { 
__p+='\n		<div class="predictive-search-articles">\n			<h3 id="predictive-search-articles" class="predictive-search__heading">Articles</h3>\n			<ul id="predictive-search-results-articles-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-articles">\n				';
 $(articleSuggestions).each(function() { 
__p+='\n					<li id="predictive-search-option-article" class="predictive-search__list-item" role="option" aria-selected="false">\n						<a href="'+
((__t=( this.url ))==null?'':__t)+
'" class="predictive-search__item link link--text" tabindex="-1">\n							<div class="predictive-search__item-content">\n								<p class="predictive-search__item-heading predictive-search__item-article-result">'+
((__t=( this.title ))==null?'':__t)+
'</p>\n							</div>\n						</a>\n					</li>\n				';
 }) 
__p+='\n			</ul>\n		</div>\n		';
 } 
__p+='\n\n	</div>\n</div>\n		   \n';
}
return __p;
};
